<template>
  <div :class="$style.wrapper">
    <div
      :class="$style.content"
      @mouseenter="handleMouseEnter"
      @mouseleave="handleMouseLeave"
      @click="handleMouseEnter"
    >
      <div
        :class="[
          $style.counter,
          score === 0 && $style.disabled,
          name || $style.notActive
        ]"
      >
        <BaseAvatar
          :url="avatar"
          :class="$style.avatarWrapper"
          :is-hover="isHover"
        >
          <template
            v-if="showdetail"
            v-slot:overlay
          >
            <div
              @click="handleOpenAthleteDetail({athleteId: id})"
            >
              <font-awesome-icon
                icon="eye"
                size="sm"
              />
            </div>
          </template>
        </BaseAvatar>
        <span
          v-if="name && showdetail && !isHover"
          :class="$style.score"
        >
          {{ score }}
        </span>
      </div>
      <span :class="$style.nameText">{{ name[$i18n.locale] }}</span>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import BaseAvatar from '@/components/Atoms/BaseAvatar'
import { DEFAULT_LOCALIZED_PROP } from '@/constants/trans'

export default {
  name: 'BaseAthleteScoreCircle',
  components: { BaseAvatar },
  props: {
    id: {
      type: Number,
      required: false,
      default: null,
    },
    name: {
      type: Object,
      required: false,
      default: () => DEFAULT_LOCALIZED_PROP,
    },
    score: {
      type: Number,
      required: false,
      default: 0,
    },
    avatar: {
      type: String,
      required: false,
      default: '',
    },
    showdetail: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      isHover: null,
    }
  },
  methods: {
    ...mapActions({
      handleOpenAthleteDetail: 'athletes/detail/openAthleteDetail',
    }),
    handleClick() {
      this.$emit('click')
    },
    handleMouseEnter() {
      this.isHover = true
    },
    handleMouseLeave() {
      this.isHover = false
    },
  },
}
</script>

<style module lang="scss">
  @import "../../assets/scss/variables";
  .wrapper {
    display: inline-block;
    font-weight: 400;

    .content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    .counter {
      color: #fff;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 2rem;
      width: 70px;
      height: 70px;
      position: relative;
      .avatarWrapper {
        position: absolute;
        height: 100%;
        width: 100%;
        img {
          height: 100% !important;
          width: 100% !important;
        }
        z-index: 1;
      }
      .score {
        z-index: 2;
        text-shadow: 1px 1px 5px black;
      }
    }
    .disabled {
      cursor: none;
    }
    .nameText {
      font-size: $font-size-small;
    }

    .notActive {
    }
  }
</style>
